import React from 'react';
import './Spinner.css'; // Import the CSS file
import spinnerImage from '../../logo.png';

export const CircleSpinner = () => {
 // return <div className="spinner"></div>;
 return <img src={spinnerImage} alt="Loading..." className="spinner-image" />;
};
